export const ShopperLoginStates = {
    LOGGED_IN: 'LOGGED_IN',
    LOGGED_OUT: 'LOGGED_OUT',
  };

export const ShopperProgressStates = {
    BROWSING: 'BROWSING',
    ITEMS_IN_CART: 'ITEMS_IN_CART',
    CHECKOUT: 'CHECKOUT',
    COMPLETED: 'COMPLETED'
};

export const Pages = { 
  HOME: 'HOME',
  ABOUT: 'ABOUT',
  STORE: 'STORE',
  LOGIN: 'LOGIN',
};